/** A bounded optional Gemini direction. Empty values retain the legacy no-style request. */
export function readCompanySpeechStyle(value:unknown):string|undefined{
  if(value===undefined)return undefined;
  if(typeof value!=='string')throw Error('음성 스타일 지시를 확인해 주세요.');
  const style=value.trim();
  if(!style)return undefined;
  if(style.length>1000||/[\u0000-\u001f\u007f-\u009f]/u.test(style)||/[\ud800-\udbff](?![\udc00-\udfff])|(?<![\ud800-\udbff])[\udc00-\udfff]/u.test(style))
    throw Error('음성 스타일 지시는 1000자 이하의 일반 문구로 입력해 주세요.');
  return style;
}
